// extracted by mini-css-extract-plugin
module.exports = {"textareaContainer":"styles_textareaContainer__1NKqf","label":"styles_label__2CJ0L","textarea":"styles_textarea__381lg","error":"styles_error__2FRz5","hint":"styles_hint__3B4z_"};